import { render, staticRenderFns } from "./AssignRoomSingleDialog.vue?vue&type=template&id=08c3c6d8&scoped=true"
import script from "./AssignRoomSingleDialog.vue?vue&type=script&lang=js"
export * from "./AssignRoomSingleDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignRoomSingleDialog.vue?vue&type=style&index=0&id=08c3c6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3c6d8",
  null
  
)

export default component.exports